import React, { useRef, useEffect, useState } from "react";
import Menu from "../../components/sturtural/Menu";
import { FileUpload } from 'primereact/fileupload';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { useNavigate } from "react-router-dom";
import { Tag } from 'primereact/tag';
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import { Chip } from 'primereact/chip';
import { storage } from "../../helpers/storage";

const CargaArchivos = () => {

    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalArchivos, setTotalArchivos] = useState(0);
    const [archivosGuardados, setArchivosGuardados] = useState(0);
    const [limiteArchivos, setLimiteArchivos] = useState(0);

    const toast = useRef(null);
    const navigate = useNavigate();
    const perfil = storage.get('perfilid');
    const id = storage.get('id');
    const ciclo = storage.get('ciclo')

    const uploadOptions = { style: { display: 'none' } };

    useEffect(() => {
        if (![1, 2, 13, 16].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        if (ciclo !== null)
            if (ciclo.IdCicloEscolar >= 6 && perfil == 16)
                navigate('/maquila')
    }, [ciclo]);

    useEffect(() => {
        obtenerArchivos();
    }, [])

    useEffect(() => {
        console.log(files)
    }, [files])
    const onTemplateRemove = (file, callback) => {
        callback();
    }

    const obtenerArchivos = () => {
        helpHttp().post(`${BASE_API}Usuarios/spdCrudArchivoUsuarios`, {
            body: {
                Opcion: "S",
                id: null,
                IdUsuario: id,
                NombreArchivo: "",
                RutaArchivo: "",
                TipoArchivo: "",
                FechaCreate: new Date().toISOString(),
                Activo: true,
                IdCicloEscolar: ciclo.IdCicloEscolar
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }

        }).then(res => {
            if (res.ITEMS[0].ID !== 0) {
                setTotalArchivos(res.ITEMS.length);
                setArchivosGuardados(res.ITEMS.length);
            } else {
                setTotalArchivos(0);
                setArchivosGuardados(0);
            }
            setLimiteArchivos(JSON.parse(res.ITEMS[0].json)[0].LimiteArchivos)
        })
    }

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result
            .replace('data:', '')
            .replace(/^.+,/, ''));
        reader.onerror = reject;
    });

    const SubirArchivos = async () => {

        console.log(files)
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf', /*'application/zip', 'application/vnd.rar'*/];

        const invalidFiles = files.filter(adjunto =>
            !allowedTypes.includes(adjunto.type.toLowerCase())
        );
        if (files.length > 0) {
            if (invalidFiles.length === 0) {
                if (totalArchivos <= limiteArchivos) {
                    setLoading(true)
                    for (let x = 0; files.length > x; x++) {
                        helpHttp().post(`${BASE_API}Usuarios/spdCrudArchivoUsuarios`, {
                            body: {
                                Opcion: "C",
                                id: null,
                                IdUsuario: id,
                                NombreArchivo: files[x].name,
                                RutaArchivo: "",
                                TipoArchivo: (`.${files[x].name.split('.').pop()}`),
                                FechaCreate: new Date().toISOString(),
                                Activo: true,
                                Archivo: await toBase64(files[x]),
                                IdCicloEscolar: ciclo.IdCicloEscolar
                            },
                            headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "Accept": "application/json",
                                'Authorization': `Bearer ${storage.get('token')}`
                            }
                        }).then(res => {
                            if (res.SUCCESS) {
                                if (files.length - 1 === x) {
                                    navigate('/archivos')
                                    setLoading(false)
                                }
                            }
                        })
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Límite de archivos excedido. Ya tiene ' + archivosGuardados + ' de ' + limiteArchivos + ' archivos permitidos.', life: 5000 })
                }
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Archivos no válidos. Solo se permiten archivos PNG, JPG, JPEG, PDF.', life: 5000 })
            }
        }
    }

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    {(/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(file.name) && <img alt={file.name} role="presentation" src={file.objectURL} width={100} />}
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    return (
        <>
            <Menu link='' />

            <Toast ref={toast}></Toast>
            <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
            <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
            <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

            <div className="grid card">
                <div className="col-12">
                    <h3 className="text-center">Carga de evidencias de entrega</h3>
                    {/* <Chip label={totalArchivos + ' de ' + limiteArchivos + ' archivos por subir.'} style={{ backgroundColor: '#9b2f3e', color: 'white' }} className="mb-4" /> */}
                    <FileUpload multiple maxFileSize="3000000" invalidFileSizeMessageSummary="{0}: Tamaño de archivo inválido." invalidFileSizeMessageDetail=" El máximo es de 3 MB." accept=".pdf, .png, .jpg, .pdf .jpeg, .zip, .rar" emptyTemplate={<p className="p-m-0">Arrastra y suelta archivos aquí para subir.</p>} itemTemplate={itemTemplate} chooseLabel="Elegir archivo" cancelLabel="Borrar todo" uploadOptions={uploadOptions}
                        onSelect={e => {
                            const _files = [...files]
                            let _total = totalArchivos
                            e.files.forEach(x => {
                                if (files.every(obj => obj.name !== x.name) || files.length === 0 || x.fileSize < 2000000) {
                                    _files.push(x)
                                    setFiles(_files)
                                    _total++
                                }
                            })
                            setTotalArchivos(_total)
                        }}
                        onRemove={e => {
                            const _files = [...files];
                            let _total = totalArchivos
                            const res = _files.filter((obj) => obj.name !== e.file.name)
                            setTotalArchivos(_total - 1)
                            setFiles(res)
                        }}
                        onClear={() => {
                            setFiles([]);
                            setTotalArchivos(totalArchivos - files.length)
                        }} />
                    <label className="ml-3 mt-2">El límite de carga es 3MB por archivo. </label>
                </div>

                <div className="text-right">
                    <Button
                        type='button'
                        name="button-abrirArchivo"
                        id="button-generar"
                        disabled={''}
                        label="Cancelar"
                        onClick={() => navigate('/archivos')}
                        className="p-button-outlined p-component"
                    />
                    <Button
                        type='button'
                        name="button-abrirArchivo"
                        id="button-generar"
                        disabled={''}
                        loading={loading}
                        label="Guardar"
                        onClick={() => SubirArchivos()}
                        className="p-button p-component ml-3"
                    />

                </div>
            </div>
        </>
    )
}
export default CargaArchivos;